export default {
  customer: state => state.customer,
  customers: state => state.customers,
  filters: state => state.filters,
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  isCallingCustomers: state => state.isCallingCustomers,
  errors: state => state.errors,
  // TODO check if used in customers
  userRoles: () => ['ROLE_BOOKKEEPER', 'ROLE_REGULAR']

}
